<template>
  <WithBackdrop
    :backdrop="data?.fields?.backdrop"
    :class="[$style.config, $style.wrap]"
  >
    <div :class="$style.inner">
      <header :class="$style.header">
        <BaseHeading size="h4" as="h2" :class="$style.heading">
          {{ data?.fields?.header }}
        </BaseHeading>
        <MarkedParser
          :md="data?.fields?.copy"
          :class="['u-fs-p1', $style.copy]"
        />
        <CallToAction
          v-for="cta in data.fields.ctas"
          :key="cta?.sys?.id"
          :class="$style.cta"
          :cta="cta"
        />
      </header>
      <div :class="$style.benefits">
        <div
          v-for="media in computedMedia"
          :key="media?.sys?.id"
          :class="$style.benefit"
        >
          <BasePicture
            :src="`${media?.fields?.image?.fields?.file?.url}?fit=thumb&q=90`"
            alt=""
            :img-class="$style.image"
          />
          <MarkedParser
            :md="media?.fields?.copy"
            :class="['u-fs-p1', $style.benefitCopy]"
          />
        </div>
      </div>
    </div>
  </WithBackdrop>
</template>

<script setup lang="ts">
import type { TypeContentBlockWithoutUnresolvableLinksResponse } from '~/types/contentful'

const props = defineProps<{
  data: TypeContentBlockWithoutUnresolvableLinksResponse
}>()

const computedMedia = computed(() =>
  props.data?.fields?.references?.filter?.(instanceOfMedia),
)
</script>

<style lang="scss" module>
.config {
  @include breakpoint-variables(
    '--we-wrap-padding',
    (
      base: 45px 20px,
      md: 60px 20px,
    )
  );
}

.wrap {
  padding: var(--we-wrap-padding);
}

.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  max-width: 800px;
  margin: 0 auto;

  @include media('md') {
    flex-direction: row;
    gap: 60px;
    max-width: 1400px;
  }

  @include media('lg') {
    gap: 120px;
  }
}

.header {
  text-align: center;
  width: 100%;

  @include media('md') {
    text-align: left;
    max-width: 500px;
  }
}

.heading {
  margin-bottom: 10px;
}

.copy {
  margin-bottom: 15px;

  @include media('md') {
    margin-bottom: 30px;
  }
}

.benefits {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 60px;
  row-gap: 45px;
  margin-top: 45px;

  @include media('xs') {
    grid-template-columns: 1fr 1fr;
    row-gap: 60px;
  }

  @include media('md') {
    margin-top: 0;
    margin-left: auto;
  }

  @include media('lg') {
    column-gap: 120px;
  }
}

.benefit {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @include media('md') {
    align-items: flex-start;
    text-align: left;
    max-width: 250px;
  }
}

.image {
  width: 100%;
  max-width: 50px;
}

.benefitCopy {
  font-weight: 600;
  margin-top: 5px;

  @include media('xs') {
    margin-top: 10px;
  }
}
</style>
